import React from "react";
import { formataData } from "../../../helpers/mesesHelper";
import Badge from "../../../components/Common/Badge";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import PropTypes from "prop-types";

function DocumentosObrigatoriosDataTable({
  linhas,
  togUploadArquivoModal,
  downloadDocumento,
  visualizarDocumento,
  togSubstituirArquivoModal,
  setSemMovimentacao,
  togPeriodoPersonalizadoModal,
}) {
  const colunas = React.useMemo(
    () => [
      {
        Header: "Documento",
        accessor: "tipo_documento",
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="col">
            <div>{row.original.tipo_documento}</div>
            {row.original?.desc && (
              <div>
                <strong>
                  <pre>{row.original?.desc}</pre>
                </strong>
              </div>
            )}
          </div>
        ),
      },
      {
        Header: "Prazo de envio",
        disableSortBy: true,
        accessor: "prazo",
      },
      {
        Header: "Status",
        Cell: ({ row }) => {
          const hoje = new Date();
          const prazoParts = row.original.prazo.split("/");
          const prazo = new Date(
            `${prazoParts[2]}-${prazoParts[1]}-${prazoParts[0]}`
          );
          const dataEnvio = row.original.data_envio
            ? new Date(row.original.data_envio)
            : null;

          let badge = null;

          if (dataEnvio) {
            const badges = [];
            if (row.original.caminho === "-") {
              badges.push(
                <Badge key="sem-movimentacao" color="info">
                  Sem movimentação
                </Badge>
              );
            }
            if (dataEnvio > prazo) {
              badges.push(
                <Badge key="enviado-atraso" color="orange">
                  Enviado em atraso: {formataData(row.original.data_envio)}
                </Badge>
              );
            } else {
              badges.push(
                <Badge key="enviado-em" color="success">
                  Enviado em: {formataData(row.original.data_envio)}
                </Badge>
              );
            }
            badge = <>{badges}</>;
          } else {
            if (prazo < hoje) {
              badge = <Badge color="danger">Em atraso</Badge>;
            } else {
              badge = <Badge color="warning">Pendente</Badge>;
            }
          }

          return (
            <div
              className="mb-2"
              role="group"
              style={{ display: "flex", gap: "5px" }}
            >
              {badge}
            </div>
          );
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        largura: "150px",
        Cell: ({ row }) => {
          var status = [];

          if (row.original.tipo_documento === "Extrato bancário") {
            if (row.original.caminho)
              status.push(
                <>
                  <DropdownButton
                    key={`download-extrato-${row.original.titulo}`}
                    onClick={() => {
                      const caminho = row.original.caminho.split(".");
                      downloadDocumento(caminho[0], caminho[1]);
                    }}
                    color="success"
                    icon="mdi mdi-cloud-download"
                  >
                    Download
                  </DropdownButton>
                  <DropdownButton
                    key={`visualizar-extrato-${row.original.titulo}`}
                    onClick={() => {
                      const caminho = row.original.caminho.split(".");
                      visualizarDocumento(caminho[0]);
                    }}
                    color="info"
                    icon="mdi mdi-file-search"
                  >
                    Visualizar
                  </DropdownButton>
                  <DropdownButton
                    key={`substituir-extrato-${row.original.titulo}`}
                    onClick={() => {
                      togSubstituirArquivoModal(1);
                    }}
                    color="warning"
                    icon="mdi mdi-file-replace"
                  >
                    Substituir
                  </DropdownButton>
                </>
              );
            else
              status.push(
                <>
                  <DropdownButton
                    key={`upload-extrato-${row.original.titulo}`}
                    onClick={() => {
                      togUploadArquivoModal(1);
                    }}
                    color="primary"
                    icon="mdi mdi-file-upload"
                  >
                    Upload
                  </DropdownButton>
                  <DropdownButton
                    key={`periodo-extrato-${row.original.titulo}`}
                    onClick={togPeriodoPersonalizadoModal}
                    color="secondary"
                    icon="mdi mdi-clock"
                  >
                    Período personalizado
                  </DropdownButton>
                </>
              );
          } else if (row.original.tipo_documento === "Notas fiscais") {
            if (row.original.caminho && row.original.caminho === "-")
              status.push(
                <>
                  <DropdownButton
                    key={`substituir-extrato-${row.original.titulo}`}
                    onClick={() => {
                      togSubstituirArquivoModal(2);
                    }}
                    color="primary"
                    icon="mdi mdi-file-upload"
                  >
                    Upload
                  </DropdownButton>
                </>
              );
            else if (row.original.caminho && row.original.caminho !== "-")
              status.push(
                <>
                  <DropdownButton
                    key={`download-extrato-${row.original.titulo}`}
                    onClick={() => {
                      const caminho = row.original.caminho.split(".");
                      downloadDocumento(caminho[0], caminho[1]);
                    }}
                    color="success"
                    icon="mdi mdi-cloud-download"
                  >
                    Download
                  </DropdownButton>
                  <DropdownButton
                    key={`substituir-extrato-${row.original.titulo}`}
                    onClick={() => {
                      togSubstituirArquivoModal(2);
                    }}
                    color="warning"
                    icon="mdi mdi-file-replace"
                  >
                    Substituir
                  </DropdownButton>
                </>
              );
            else
              status.push(
                <>
                  <DropdownButton
                    key={`upload-notas-${row.original.titulo}`}
                    onClick={() => {
                      togUploadArquivoModal(2);
                    }}
                    color="primary"
                    icon="mdi mdi-file-upload"
                  >
                    Upload
                  </DropdownButton>
                  <DropdownButton
                    key={`movimentacao-notas-${row.original.titulo}`}
                    onClick={setSemMovimentacao}
                    color="secondary"
                    icon="mdi mdi-cash-remove"
                  >
                    Sem movimentação
                  </DropdownButton>
                </>
              );
          }

          return <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [
      downloadDocumento,
      setSemMovimentacao,
      togSubstituirArquivoModal,
      togUploadArquivoModal,
      visualizarDocumento,
      togPeriodoPersonalizadoModal,
    ]
  );

  return (
    <>
      <CommonDataTable colunas={colunas} linhas={linhas} botoes={<></>} />
    </>
  );
}

DocumentosObrigatoriosDataTable.propTypes = {
  linhas: PropTypes.arrayOf(
    PropTypes.shape({
      titulo: PropTypes.string.isRequired,
      ativo: PropTypes.string.isRequired,
    })
  ).isRequired,
  togUploadArquivoModal: PropTypes.func.isRequired,
  downloadDocumento: PropTypes.func.isRequired,
  visualizarDocumento: PropTypes.func.isRequired,
  togSubstituirArquivoModal: PropTypes.func.isRequired,
  setSemMovimentacao: PropTypes.func.isRequired,
  togPeriodoPersonalizadoModal: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default DocumentosObrigatoriosDataTable;
